// src/components/Role/RoleForm.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getRoleById, createRole, updateRole } from '../../services/api';
import { Form, Input, Button, message, Checkbox } from 'antd';

const RoleForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) fetchRole();
  }, [id]);

  const fetchRole = async () => {
    setLoading(true);
    try {
      const response = await getRoleById(id);
      form.setFieldsValue(response.data);
    } catch (error) {
      message.error('Failed to fetch role');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (id) {
        await updateRole(id, values);
        message.success('Role updated successfully');
      } else {
        await createRole(values);
        message.success('Role created successfully');
      }
      navigate('/roles');
    } catch (error) {
      message.error(id ? 'Failed to update role' : 'Failed to create role');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} onFinish={handleSubmit} layout="vertical">
      <Form.Item name="roleId" hidden>
        <Input />
      </Form.Item>
      <Form.Item
        name="roleName"
        label="Role Name"
        rules={[{ required: true, message: 'Please input role name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {id ? 'Update' : 'Create'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default RoleForm;
